<template>
  <div>
    <breadCrumb
      :icon="'fa-user-friends'"
      :category="$t(`sideNav.navSalonSetting`)"
      :subCategory="$t(`subMenu.salon_setting_staff`)"
      :subSubCategory="''">
    </breadCrumb>
    <div v-if="!addStaffToggle" class="text-right mt-3 mr-5">
      <!-- <button
        class="btn buttons-csv buttons-html5 btn-outline-primary"
        type="button"
        title="Add New Staff"
        @click="addStaffToggle = !addStaffToggle"
      >
        <span class="fal fa-plus mr-2"></span>
        <span>{{
          $t("button_link.add") + $t(`subMenu.salon_setting_staff`)
        }}</span>
      </button> -->
      <button
        class="btn buttons-csv buttons-html5 btn-outline-primary"
        type="button"
        title="Add New Staff"
        @click="addStaff">
        <!-- v-b-toggle.addStaffDrawer -->
        <span class="fal fa-plus mr-2"></span>
        <span>{{
          $t("button_link.add") + $t(`subMenu.salon_setting_staff`)
        }}</span>
      </button>
    </div>
    <div v-if="addStaffToggle" class="px-3 px-sm-5 py-4">
      <div class="panel mb-0">
        <div class="panel-hdr">
          <h2>
            {{ $t("button_link.add") + $t(`subMenu.salon_setting_staff`) }}
          </h2>
        </div>
        <div class="panel-container show">
          <div class="panel-content">
            <!-- <staffForm
              ref="staffForm"
              :isEdit="false"
              @submitStaffDetails="addStaff"
              @returnStaffList="closeModal"
            ></staffForm> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="!addStaffToggle" class="px-3 px-sm-5 py-4">
      <div class="panel mb-0">
        <div class="panel-hdr d-block pt-4 p-3">
          <div class="ml-auto mb-3 text-right">
            <exportCSV
              class="link btn buttons-csv buttons-html5 btn-primary mr-2"
              :data="exportData"
              :fields="exportFields"
              :header="exportHeaders"
              type="csv"
              :escapeCsv="false"
              :name="exportFileName">
              <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-6 mb-2 align-items-center justify-content-start">
              <div class="dataTables_filter">
                <label class="d-flex mb-0">
                  <input
                    type="search"
                    class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                    :placeholder="$t('label.search')"
                    v-model="searchStaff"
                    @keypress.enter="filterSearchStaff" />
                  <button
                    class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                    @click="filterSearchStaff">
                    <i class="fas fa-search"></i>
                  </button>
                </label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
              <div class="form-group d-flex">
                <div class="input-group-prepend w-100">
                  <label
                    class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                    <i class="fas fa-store"></i>
                  </label>
                  <multiselect
                    v-model="selectedOutlet"
                    label="text"
                    track-by="id"
                    :options="outlet"
                    :searchable="false"
                    :show-labels="false"
                    openDirection="below"
                    @select="filterByOutlet">
                    <template slot="option" slot-scope="{ option }">{{
                      option.text
                    }}</template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
          <a class="link text-primary" @click="clearFilter">{{
            $t("button_link.clear_filter")
          }}</a>
        </div>
        <div class="panel-container show">
          <div class="panel-content">
            <div
              v-if="isSpinnerShow"
              class="d-flex justify-content-center mt-3 mb-3">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div
              class="panel-tag mt-3"
              v-if="!isSpinnerShow && totalEntries == 0">
              {{ $t("table.no_records") }}
            </div>
            <div
              v-if="!isSpinnerShow && totalEntries != 0"
              class="dataTables_wrapper dt-bootstrap4">
              <div class="row justify-content-end">
                <div class="col-auto pt-2">
                  <span>{{
                    $t("table.pagination", {
                      startPage: startPage,
                      endPage: endPage,
                      totalEntries: totalEntries,
                    })
                  }}</span>
                </div>
                <div class="col-auto">
                  <b-pagination
                    class="ml-3"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalEntries"
                    @input="handlePagination"
                    aria-controls="tblCDR"></b-pagination>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 overflow-auto">
                  <b-table-simple>
                    <b-thead>
                      <b-tr>
                        <b-td> # </b-td>
                        <b-td> Photo </b-td>
                        <b-td> Staff Information </b-td>
                        <b-td> Performance Target </b-td>
                        <b-td> Permission </b-td>
                        <b-td> Staff Role </b-td>
                        <b-td> Leave Day </b-td>
                        <!-- <b-td></b-td> -->
                        <b-td></b-td>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(item, index) in staffItems" :key="index">
                        <b-td>
                          {{ index + 1 }}
                        </b-td>
                        <b-td class="">
                          <div class="d-flex justify-content-center">
                            <b-avatar
                              :src="getStaffImage(item)"
                              size="6rem"></b-avatar>
                          </div>
                        </b-td>
                        <b-td class="hoverColumn"
                          @click="editStaffDetails(item)"
                          v-b-modal.editStaffDetailsModal>
                          <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center">
                              <b-icon icon="person" class="mr-2"></b-icon>
                              <span class="text-bold">{{ item.name }}</span>
                            </div>
                            <a>
                              <b-icon
                                variant="primary"
                                icon="pencil"></b-icon>
                            </a>
                          </div>
                          <div class="d-flex align-items-center">
                            <b-icon icon="phone" class="mr-2"></b-icon>
                            {{ item.mobile }}
                          </div>
                          <div class="d-flex align-items-center">
                            <b-icon icon="card-text" class="mr-2"></b-icon>
                            {{
                              item.employee.nationalID != ""
                              ? item.employee.nationalID
                              : "N/A"
                            }}
                          </div>
                        </b-td>
                        <b-td class="hoverColumn"
                          @click="editStaffTargets(item)"
                          v-b-modal.editStaffTargetsModal>
                          <div class="row">
                            <div class="col mr-2">
                              <ul class="pl-3">
                                <li class="pl-0">
                                  <span>Service:</span>
                                  <span>{{ item.target.service }}</span>
                                </li>
                                <li class="pl-0">
                                  <span>Product: </span>
                                  <span>{{ item.target.product }}</span>
                                </li>
                                <li class="pl-0">
                                  <span>Package: </span>
                                  <span>{{ item.target.package }}</span>
                                </li>
                                <li class="pl-0">
                                  <span>Outstanding: </span>
                                  <span>{{ item.target.outstanding }}</span>
                                </li>
                                <li v-if="item.target.includeRedeem" class="pl-0">
                                  <span>Include Redeem Value</span>
                                </li>
                              </ul>
                            </div>
                            <div class="col-auto">
                              <a>
                                <b-icon
                                  variant="primary"
                                  icon="pencil"></b-icon>
                              </a>
                            </div>
                          </div>
                        </b-td>
                        <b-td>
                          <div class="d-flex flex-column">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.showOnline"
                                @input="
                                  permissionChange(
                                    $event,
                                    item.staffID,
                                    'online'
                                  )
                                  "
                                switch>Show for Online</b-form-checkbox>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.showWork"
                                @input="
                                  permissionChange($event, item.staffID, 'work')
                                  "
                                switch>Show for Worksheet</b-form-checkbox>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.showAppt"
                                @input="
                                  permissionChange($event, item.staffID, 'appt')
                                  "
                                switch>Show for Appointment</b-form-checkbox>
                            </div>
                            <!-- <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.enable"
                                @input="
                                  permissionChange(
                                    $event,
                                    item.staffID,
                                    'enable'
                                  )
                                  "
                                switch>Show for Target user in App</b-form-checkbox>
                            </div> -->
                          </div>
                        </b-td>
                        <b-td class="hoverColumn"
                          @click="editStaffRole(item)"
                          v-b-modal.editStaffRoleModal>
                          <div class="row">
                            <div class="col mr-2">
                              <div v-if="item.carwasher.carwasherID">
                                <div class="badge badge-primary pl-3 pr-3">WASHER</div>
                              </div>
                              <div v-if="item.doctor.doctorID">
                                <div class="badge badge-warning pl-3 pr-3">DOCTOR</div>
                              </div>
                              <div v-if="item.stockist.stockistID">
                                <div class="badge badge-info pl-3 pr-3">STOCKIST</div>
                              </div>
                              <div v-if="!item.carwasher.carwasherID && !item.doctor.doctorID && !item.stockist.stockistID">
                                <div class="badge badge-success pl-3 pr-3">STAFF</div>
                              </div>
                            </div>
                            <div class="col-auto">
                              <a>
                                <b-icon
                                  variant="primary"
                                  icon="pencil"></b-icon>
                              </a>
                            </div>
                          </div>
                        </b-td>
                        <b-td class="hoverColumn"
                          @click="editStaffLeave(item)"
                          v-b-modal.editStaffLeaveModal>
                          <div class="row">
                            <div v-if="item.leaveDayDate" class="col mr-2">
                              <span>{{ item.leaveDayDate }}</span>
                              <ul class="pl-3">
                                <li class="pl-0">
                                  <span>Total: </span>
                                  <span>{{ item.leaveDayTotal }}</span>
                                </li>
                                <li class="pl-0">
                                  <span>Used: </span>
                                  <span>{{ item.leaveDayUsed }}</span>
                                </li>
                              </ul>
                            </div>
                            <div v-else class="col mr-2">
                              -
                            </div>
                            <div class="col-auto">
                              <a>
                                <b-icon
                                  variant="primary"
                                  icon="pencil"></b-icon>
                              </a>
                            </div>
                          </div>
                        </b-td>
                        <b-td class="align-items-center">
                          <a
                            class="link"
                            @click="deleteStaff(item.staffID, item.name)">
                            <b-icon
                              variant="danger"
                              style="font-size: 15px"
                              icon="trash"></b-icon>
                          </a>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="editStaffDetailsModal" size="lg" title="Edit Staff Details">
      <div v-show="!staffDetails.id" class="form-group">
        <label>Outlet</label>
        <multiselect
          v-model="staffOutlet"
          label="text"
          track-by="id"
          :options="outlet"
          :searchable="false"
          :show-labels="false"
          openDirection="below"
          @select="selectStaffOutlet">
          <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
      <div class="form-group">
        <label>Name</label>
        <b-form-input v-model="staffDetails.name" type="text"></b-form-input>
      </div>
      <div class="form-group">
        <label>Mobile Number</label>
        <b-form-input
          v-model="staffDetails.mobile"
          type="text"
          @keyup="contactValidation"></b-form-input>
        <div id="err" class="error-validation"></div>
        <div class="help-block fs-xs">
          <p class="mb-0">{{ $t('message.contact_validation.notes') }}:</p>
          <ul>
            <li>{{ $t('message.contact_validation.my') }} 601x xxx xxxx</li>
            <li>{{ $t('message.contact_validation.sg') }} 65x xxx xxxx</li>
          </ul>
        </div>
      </div>
      <div class="form-group">
        <label>National ID</label>
        <b-form-input
          v-model="staffDetails.nationalID"
          type="text"></b-form-input>
      </div>
      <div class="form-group">
        <label>Employee Number</label>
        <b-form-input v-model="staffDetails.empNum" type="text"></b-form-input>
      </div>
      <div class="form-group">
        <label>Image</label>

        <div id="imageContainer" v-if="staffDetails.icon && staffDetails.icon !== staffIconDefault" class="text-center mt-3">
          <div class="text-right mb-2 mr-2">
            <button v-show="!dzShow" class="btn btn-sm btn-outline-primary" type="button"
              :title="$t('header.delete_image')"
              @click="showDeleteImageModal">
              <span class="fal fa-trash"></span>
            </button>
          </div>
          <a @click="handleDropzone('img-thumbnail')" :title="$t('button_link.click_upload')" class="m-auto">
            <img class="img-fluid img-thumbnail" :src="staffDetails.icon" />
          </a>
        </div>

        <vue-dropzone
          v-show="!staffDetails.icon || staffDetails.icon === staffIconDefault"
          ref="dropzone"
          class="text-center"
          id="dropLogo"
          :options="dropOptions"
          @vdropzone-success="dropzoneAdd"
          @vdropzone-removed-file="dropzoneRemoved">
        </vue-dropzone>

        <div v-if="dzShow" class="mt-2">
          <div class="row">
            <div class="col">
              <h6 class="text-dark fs-sm">{{ $t('header.upload_image') }}: </h6>
            </div>
            <div class="col text-right">
              <a id="uploadCancel" class="cancel link" @click="handleDropzone('item-image')">
                {{ $t('button_link.cancel') }}
              </a>
            </div>
          </div>
          <vue-dropzone
            ref="dropzone"
            class="text-center"
            id="dropzoneAdd"
            :options="dropOptions"
            @vdropzone-success="dropzoneAdd"
            @vdropzone-removed-file="dropzoneRemoved">
          </vue-dropzone>
        </div>

      </div>
      <div v-show="!staffDetails.id" class="form-group">
          <b-form-checkbox v-model="showOnline" switch>Show for Online</b-form-checkbox>
      </div>
      <div v-show="!staffDetails.id" class="form-group">
          <b-form-checkbox v-model="showWork" switch>Show for Worksheet</b-form-checkbox>
      </div>
      <div v-show="!staffDetails.id" class="form-group">
          <b-form-checkbox v-model="showAppt" switch>Show for Appointment</b-form-checkbox>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="closeModal('editStaffDetailsModal')">Cancel</b-button>
            <b-button variant="primary" class="ml-2" @click="editDetails()">Save</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="editStaffTargetsModal" title="Edit Staff Targets">
      <div class="row">
        <div class="col-12 mb-3">
          Staff: <b>{{ staffDetails.name }}</b>
        </div>
        <div class="col-6 mt-2">
          <label>Service</label>
          <b-form-input
            v-model="staffDetails.service"
            type="number">
          </b-form-input>
        </div>
        <div class="col-6 mt-2">
          <label>Product</label>
          <b-form-input
            v-model="staffDetails.product"
            type="number">
          </b-form-input>
        </div>
        <div class="col-6 mt-2">
          <label>Package</label>
          <b-form-input
            v-model="staffDetails.package"
            type="number">
          </b-form-input>
        </div>
        <div class="col-6 mt-2">
          <label>Outstanding</label>
          <b-form-input
            v-model="staffDetails.outstanding"
            type="number">
          </b-form-input>
        </div>
        <div class="col-12 mt-3">
          <div class="custom-control custom-switch">
            <input
              v-model="staffDetails.includeRedeem"
              type="checkbox"
              class="custom-control-input"
              id="includeRedeem">
            <label class="custom-control-label" for="includeRedeem">Include Redeem Value</label>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="closeModal('editStaffTargetsModal')">Cancel</b-button>
            <b-button variant="primary" class="ml-2" @click="editTargets()">Confirm</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="editStaffRoleModal" title="Edit Staff Roles">
      <div class="col-12 mb-3">
        Staff: <b>{{ staffDetails.name }}</b>
      </div>
      <div class="col-12 mt-2">
        <div class="custom-control custom-switch">
          <input
            v-model="staffDetails.carwasher"
            type="checkbox"
            class="custom-control-input"
            id="role-carwasher"
            @change="onCarwasherCheckChange">
          <label class="custom-control-label" for="role-carwasher">Car Washer</label>
        </div>
      </div>
      <div class="col-12 mt-2">
        <div class="custom-control custom-switch">
          <input
            v-model="staffDetails.doctor"
            type="checkbox"
            class="custom-control-input"
            id="role-doctor"
            @change="onDoctorCheckChange">
          <label class="custom-control-label" for="role-doctor">Doctor</label>
        </div>
      </div>
      <div class="col-12 mt-2">
        <div class="custom-control custom-switch">
          <input
            v-model="staffDetails.stockist"
            type="checkbox"
            class="custom-control-input"
            id="role-stockist"
            @change="onStockistCheckChange">
          <label class="custom-control-label" for="role-stockist">Stockist</label>
        </div>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="closeModal('editStaffRoleModal')">Cancel</b-button>
            <!-- <b-button variant="primary" class="ml-2" @click="editRole()">Confirm</b-button> -->
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="editStaffLeaveModal" title="Edit Staff Leave" size="lg">
      <div class="col-12 mb-3">
        Staff: <b>{{ staffDetails.name }}</b>
      </div>
      <div v-if="staffLeaveSpinner" class="col-12 mt-2">
        <div
          class="d-flex justify-content-center mt-3 mb-3">
          <b-spinner label="Loading..."></b-spinner>
        </div>
      </div>
      <div v-if="!staffLeaveSpinner" class="col-12 mt-2" style="width: 100%; min-width: 700px;">

        <div class="row">
          <div class="col">Start Date</div>
          <div class="col">End Date</div>
          <div class="col-2">Leave Total</div>
          <div class="col-2">Leave Used</div>
          <div class="col-1"></div>
        </div>

        <div class="row pt-2" v-for="(row, index) in leaveTotal" :key="'leave-row-' + index">

          <div class="col" style="height: ">
            <date-range-picker class="w-100"
              v-model="row['start']"
              :opens="'right'"
              :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
              :autoApply="true"
              :showDropdowns="true"
              :always-show-calendars="true"
              :single-date-picker="true"
              :ranges="false"
              @update="onLeaveStartDateChange(index)">
            </date-range-picker>
            <label v-if="row['startError']" class="error-validation">{{ row['startError'] }}</label>
          </div>

          <div class="col">
            <date-range-picker class="w-100"
              v-model="row['end']"
              :opens="'right'"
              :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
              :autoApply="true"
              :showDropdowns="true"
              :always-show-calendars="true"
              :single-date-picker="true"
              :ranges="false"
              @update="onLeaveEndDateChange(index)">
            </date-range-picker>
            <label v-if="row['endError']" class="error-validation">{{ row['endError'] }}</label>
          </div>

          <div class="col-2">
            <input type="number" class="form-control" v-model="row['total']" @change="onLeaveTotalChange(index)">
            <label v-if="row['totalError']" class="error-validation">{{ row['totalError'] }}</label>
          </div>

          <div class="col-2">
            <input type="number" class="form-control" v-model="row['used']" disabled="disabled" readonly="readonly">
          </div>

          <div class="col-1">
            <!-- <button class="btn btn-sm btn-primary" type="button" @click="saveLeave(index)">
              <i class="fal fa-check"></i>
            </button> -->
            <button class="btn btn-sm btn-danger ml-2" type="button" @click="confirmDeleteLeave(index)">
              <i class="fal fa-trash"></i>
            </button>
          </div>

        </div>

        <br>
        <br>

        <button class="btn btn-sm btn-primary" type="button" @click="addLeave">
          Add Period
        </button>

        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>

      </div>
      <div class="col-12 mt-2">
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="closeModal('editStaffLeaveModal')">Cancel</b-button>
            <b-button variant="primary" class="ml-2" @click="saveLeave">Save</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="staffLeaveTotalDelete" title="Confirm delete leave setting">
      <div class="col-12">
        Confirm delete selected leave total for {{ staffDetails.name }}
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="closeModal('staffLeaveTotalDelete')">Cancel</b-button>
            <b-button variant="primary" class="ml-2" @click="deleteLeave()">Confirm</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <StaffForm :outlet="outlet" :selected="selectedOutlet" @addDone="addDone" />

    <div :class="{ 'show': errorModalShow }" class="modal fade">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content pt-3">
          <div class="modal-body d-flex align-items-center">
            <i class="fas fa-2x" :class="isError ? ['fa-exclamation-circle', 'text-danger'] : ['fa-check-circle', 'text-success']"></i>
            <p class="ml-3 mb-0" :class="isError ? ['text-danger'] : ['text-dark']">{{ errorMessage }}</p>
          </div>
          <div class="modal-footer">
            <button id="modalClose" type="button" class="btn btn-primary waves-effect waves-themed" @click="errorModalShow = false">OK</button>
          </div>
        </div>
      </div>
    </div>

    <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>

  </div>
</template>

<script>
import DeleteModal from './../../Delete_Modal'
import BreadCrumb from "./../../Bread_Crumb";
import StaffForm from "./Staff_Form_Drawer";
import vueDropzone from "vue2-dropzone";

import moment from "moment";
import {
  setReturnData,
  handleSessionExpired,
} from "./../../../../assets/js/dashboard/dashboard";
import Swal from "sweetalert2";
import DateRangePicker from 'vue2-daterange-picker'
import { contactValidation } from '@/assets/js/dashboard/utilities.js'

export default {
  name: "staff",
  components: {
    StaffForm,
    BreadCrumb,
    DateRangePicker,
    vueDropzone,
    DeleteModal,
  },
  data() {
    return {
      dateRange: { start: moment(), end: moment() },

      isSpinnerShow: false,
      addStaffToggle: false,
      editToggleModal: false,
      deleteToggleModal: false,
      staffLeaveSpinner: true,

      searchStaff: "",
      outlet: [],
      selectedOutlet: {},
      staffItems: [],

      staffIconDefault: 'https://img.tunai.io/image/s3-5710de08-ba89-4897-9b94-e0af25a45a3f.jpeg',

      staffData: [],
      staffOutlet: {},
      staffDetails: {
        id: 0,
        name: "",
        nationalID: "",
        empNum: "",
        service: 0,
        product: 0,
        package: 0,
        outstanding: 0,
        includeRedeem: false,
        mobile: "",
        mobileOriginal: '',
        carwasher: null,
        doctor: null,
        stockist: null,
        icon: '',
      },
      filePath: '',
      formItem: {},

      showOnline: false,
      showWork: false,
      showAppt: false,

      sID: 0,
      name: "",

      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,

      exportHeaders: [],
      exportData: [],
      exportFileName: "",

      staffLeaves: [],
      startDate: new moment().startOf('year'),
      endDate: new moment().endOf('year'),
      leaveTotal: 0,

      errorModalShow: false,
      isError: true,
      errorMessage: '',

      dzShow: false,
      dropOptions: {
        url: this.$api.API_IMAGE,
        addRemoveLinks: true,
        maxFiles: 1,
        paramName: 'filename',
        headers: {
          token: this.$util.getSessionToken()
        }
      },
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed text-center",
          tdClass: "text-center",
        },
        {
          key: "avatar",
          label: "Avatar",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "staff",
          label: "Staff Information",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle hoverColumn",
        },
        {
          key: "target",
          label: "Performance Target",
          thClass: "thead-themed text-center",
          tdClass: "text-center align-middle hoverColumn",
        },
        {
          key: "permission",
          label: "Permissions",
          thClass: "thead-themed text-center",
          tdClass: "text-center align-middle",
        },
        {
          key: "leave",
          label: "Leave",
          thClass: "thead-themed text-center",
          tdClass: "text-center align-middle hoverColumn",
        },
      ];
    },
    exportFields() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.mobile").toUpperCase()] = "mobile";
      ret[this.$i18n.t("outlet_setting.staff.online").toUpperCase()] = "online";
      ret[this.$i18n.t("outlet_setting.staff.work").toUpperCase()] = "worksheet";
      ret[this.$i18n.t("outlet_setting.staff.appt").toUpperCase()] = "appointment";
      ret['Service Target'] = "targetService";
      ret['Product Target'] = "targetProduct";
      ret['Package Target'] = "targetPackage";
      ret['Outstanding Target'] = "targetOutstanding";
      ret['Target Include Redeem'] = "targetIncludeRedeem";
      ret['Car Washer'] = "roleCarwasher";
      ret['Doctor'] = "roleDoctor";
      ret['Stockist'] = "roleStockist";
      return ret;
    },
  },
  methods: {
    contactValidation() {
      var err = contactValidation(this.staffDetails.mobile);
      document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
        'error': this.$i18n.t(`message.contact_validation.error.${err}`)
      })
    },

    getStaffImage(item) {
      if(item.icon && item.icon !== this.staffIconDefault) {
        return item.icon
      }

      if(item.image && item.image !== this.staffIconDefault) {
        return item.image
      }

      return this.staffIconDefault
    },

    addDone(res) {
      if (res.status === 200) {
        this.toastrExe("Add Staff", "Successfully added staff", "success");
        this.getStaffItems();
      } else {
        this.toastrExe(
          "Add Staff",
          "Failed to add staff, mobile number exists.",
          "danger"
        );
      }
    },
    permissionChange(event, staffID, permission) {
      let body = null;
      let $vm = this;
      let result = [];
      let check = null;
      let url = `${this.$api.BEBUSINESS_STAFF}/${staffID}/${permission}`;
      if (permission == "appt") body = { showAppt: event ? 1 : 0 };
      else if (permission == "work") body = { showWork: event ? 1 : 0 };
      else if (permission == "online") body = { showOnline: event ? 1 : 0 };
      else if (permission == "enable") body = { enable: event ? 1 : 0 };
      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: body,
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },

    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    closeModal(modal) {
      this.$bvModal.hide(modal);
    },

    clearFilter() {
      this.searchStaff = "";
      this.selectedOutlet = this.outlet[0];
      this.page = 0
      this.getStaffItems();
    },
    filterByOutlet(event) {
      this.selectedOutlet = event;
      this.page = 0
      this.getStaffItems();
    },
    filterSearchStaff(event) {
      this.page = 0
      this.getStaffItems()
    },
    handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        this.getStaffItems("");
      }
    },
    async getStaffItems(exportData) {
      let $vm = this

      let url = $vm.$api.API_ENDPOINT_STAFF + this.$api.BEBUSINESS_STAFF;
      url += '?outletID=' + this.selectedOutlet.id
      url += '&enable=1'

      if (this.searchStaff) {
        url += '&search=' + this.searchStaff
      }

      if (exportData) {
        url += "&page=" + this.page
      }

      if (!exportData) {
        this.isSpinnerShow = true;
      }

      this
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          let today = moment().unix()

          let staff = response.data.staffs;
          staff.forEach((element) => {
            element.showAppt = element.showAppt === 1 ? true : false;
            element.showOnline = element.showOnline === 1 ? true : false;
            element.showWork = element.showWork === 1 ? true : false;
            element.enable = element.enable === 1 ? true : false;

            let displayLeave
            let includedTodayLeave
            for (let leave of element.leaves) {
              if (leave.startDate < today && leave.endDate > today) {
                if (!includedTodayLeave) {
                  includedTodayLeave = leave
                  continue
                }

                if (includedTodayLeave.startDate < leave.startDate) {
                  includedTodayLeave = leave
                  continue
                }

                if (includedTodayLeave.endDate > leave.endDate) {
                  includedTodayLeave = leave
                  continue
                }
              }

              displayLeave = leave
            }

            if (includedTodayLeave) {
              displayLeave = includedTodayLeave
            }

            if (displayLeave) {
              element.leaveDayDate = moment.unix(displayLeave.startDate).format('DD/MM/YYYY') + ' - ' + moment.unix(displayLeave.endDate).format('DD/MM/YYYY')
              element.leaveDayTotal = displayLeave.total
              element.leaveDayUsed = displayLeave.used
            }

            // return element.deleteDate === 0
          });

          if (!exportData) {
            var retData = setReturnData(staff, staff.length, $vm.page);
            $vm.staffItems = retData.result;
            $vm.staffData = retData.result;
            $vm.totalEntries = retData.count;
            $vm.totalPage = retData.totalPage;
            $vm.startPage = retData.startPage;
            $vm.endPage = retData.endPage;

            $vm.isSpinnerShow = false;
          } else {
            this.setExportData(staff)
          }
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          } else {
            $vm.$parent.setModal(
              this,
              true,
              true,
              $vm.$i18n.t("message.error.system_error")
            );
          }
        });

      // this.getExportData()
    },
    async getExportData() {
      let $vm = this;
      let QUERY_STRING = this.$api.BEBUSINESS_STAFF
      const url = $vm.$api.API_ENDPOINT_STAFF + QUERY_STRING;

      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          this.setExportData(response.data.staffs);
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
    setExportData(data) {
      let header =
        this.$msg.REPORT.HEADER +
        this.$i18n.t("sideNav.navSalonSetting") +
        " - " +
        this.$i18n.t(`subMenu.salon_setting_staff`);

      this.exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
        moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];

      this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;

      this.exportData = [];
      for (var i = 0; i < data.length; i++) {
        this.exportData.push({
          index: i + 1,
          name: data[i].name,
          mobile: data[i].mobile,
          online: data[i].showOnline ? this.$i18n.t("outlet_setting.staff.online") : "",
          worksheet: data[i].showWork ? this.$i18n.t("outlet_setting.staff.work") : "",
          appointment: data[i].showAppt ? this.$i18n.t("outlet_setting.staff.appt") : "",
          targetService: data[i].target.service,
          targetProduct: data[i].target.product,
          targetPackage: data[i].target.package,
          targetOutstanding: data[i].target.outstanding,
          targetIncludeRedeem: data[i].target.includeRedeem ? 'Target Include Redeem' : '',
          roleCarwasher: data[i].carwasher.carwasherID ? 'Car Washer' : '',
          roleDoctor: data[i].doctor.doctorID ? 'Doctor' : '',
          roleStockist: data[i].stockist.stockistID ? 'Stockist' : '',
        });
      }
    },

    addStaff() {
      this.staffOutlet = this.selectedOutlet

      this.dzShow = false

      this.filePath = ''

      this.staffDetails.id = ''
      this.staffDetails.name = ''
      this.staffDetails.nationalID = ''
      this.staffDetails.empNum = ''
      this.staffDetails.mobile = ''
      this.staffDetails.mobileOriginal = ''
      this.staffDetails.icon = ''

      this.showOnline = true
      this.showWork = true
      this.showAppt = true

      this.$bvModal.show('editStaffDetailsModal')
    },
    selectStaffOutlet(val) {
      this.staffOutlet = val
    },

    editStaffDetails(item) {
      this.dzShow = false

      this.filePath = ''

      this.staffDetails.id = item.staffID;
      this.staffDetails.name = item.name;
      this.staffDetails.nationalID = item.employee.nationalID;
      this.staffDetails.empNum = item.employee.number;
      this.staffDetails.mobile = item.mobile;
      this.staffDetails.mobileOriginal = item.mobile;
      this.staffDetails.icon = item.icon;
    },
    async editDetails() {
      let mobile = this.staffDetails.mobile
      var err = contactValidation(mobile);
      if (err) {
        return
      }

      let data = {
        name: this.staffDetails.name,
        number: this.staffDetails.empNum,
        nationalID: this.staffDetails.nationalID,
      }

      let $vm = this;
      let url =
        this.$api.BEBUSINESS_STAFF +
        "/" +
        this.staffDetails.id +
        this.$api.STAFF_DETAIL_UPDATE;

      if (!this.staffDetails.id) {
        url = this.$api.BEBUSINESS_STAFF

        data['mobile'] = mobile
        data['outletID'] = this.staffOutlet.id
        data['showOnline'] = this.showOnline ? 1 : 0
        data['showWork'] = this.showWork ? 1 : 0
        data['showAppt'] = this.showAppt ? 1 : 0

        if(this.filePath) {
          data['icon'] = this.filePath
        }
      }

      let result = [];
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: data,
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result.status = 'error'
          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result.status !== 200) {
        if (this.staffDetails.id) {
          this.toastrExe("Staff Detail", `Update failed.`, "danger");
        } else {
          this.toastrExe(
            "Add Staff",
            "Failed to add staff, mobile number exists.",
            "danger"
          );
        }
        return
      }

      if (this.staffDetails.id && mobile !== this.staffDetails.mobileOriginal) {
        await $vm
          .$axios({
            method: "post",
            url: 'https://staff.tunai.io/business/staff/' + this.staffDetails.id + '/mobile',
            headers: { token: $vm.$session.get("token") },
            data: {
              mobile: mobile,
            },
          })
          .then(function (response) {
            result = response;
          })
          .catch((err) => {
            result.status = 'error'
            var errData = err.response;
            if (errData.error == $vm.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });

        if (result.status !== 200) {
          this.toastrExe("Staff Detail", `Update staff mobile failed.`, "danger");
          return
        }
      }

      this.$bvModal.hide("editStaffDetailsModal");
      if (this.staffDetails.id) {
        this.toastrExe(
          "Staff Detail",
          `Staff ID ${this.staffDetails.id} details have been updated`,
          "success"
        );
      } else {
        this.toastrExe("Add Staff", "Successfully added staff", "success");
      }
      this.getStaffItems();
    },
    async deleteStaff(id, name) {
      let flag = false;
      await Swal.fire({
        title: `Confirm delete Staff ${name}?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      let url = this.$api.BEBUSINESS_STAFF + "/" + id + this.$api.DELETE;
      let result = [];

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        this.toastrExe(
          "Delete Staff",
          `Staff ID: ${id} has been deleted`,
          "success"
        );
        this.getStaffItems();
      } else this.toastrExe("Delete Staff", "Error", "danger");
    },

    dropzoneAdd(file, response) {
      if (response.path == undefined) {
        this.parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
      }

      if (this.staffDetails.id) {
        let $vm = this;
        let url =
          this.$api.BEBUSINESS_STAFF +
          "/" +
          this.staffDetails.id +
          this.$api.STAFF_DETAIL_UPDATE;

        $vm.$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: { icon: response.path },
        })
          .then((res) => {
            if (res.status !== 200) {
              this.toastrExe("Staff Detail", `Update failed.`, "danger");
              return
            }

            this.staffDetails.icon = response.path
            this.$refs.dropzone.removeAllFiles()
            this.getStaffItems()
          })
          .catch((err) => {
            var errData = err.response;
            if (errData.error == $vm.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });
      } else {
        this.filePath = response.path
      }
    },
    dropzoneRemoved(file, error, xhr) {
      this.filePath = ''
    },
    handleDropzone(strClass) {
      var parent = document.getElementById("imageContainer");
      const imgs = parent.getElementsByClassName(strClass)

      var j = 0;
      if (imgs.length > 0) {
        for (var i = 0; i < imgs.length;) {
          var img = imgs[i];
          var link = img.parentElement;

          if (img.classList.contains('img-thumbnail')) {
            img.classList.remove('img-thumbnail');
            img.classList.add('item-image');

            link.classList.remove('m-auto');
            link.classList.add('mr-2');
            link.setAttribute('title', '');
            parent.classList.add('d-flex');

            this.dzShow = true;
          } else {
            img.classList.add('img-thumbnail');
            img.classList.remove('item-image');

            link.classList.add('m-auto');
            link.classList.remove('mr-2');
            link.setAttribute('title', this.$i18n.t('button_link.click_upload'));
            parent.classList.remove('d-flex')

            this.dzShow = false;
          }
          j++;
        }
      }
    },
    showDeleteImageModal() {
      var title = this.$i18n.t('header.delete_image')
      var message = this.$i18n.t('message.confirmation.delete_image')
      this.$refs.deleteModal.showModal(title, message)
    },
    deleteImage() {
      this.$refs.deleteModal.toggleModal = false

      let $vm = this;
      let url =
        this.$api.BEBUSINESS_STAFF +
        "/" +
        this.staffDetails.id +
        this.$api.STAFF_DETAIL_UPDATE;

      $vm.$axios({
        method: "post",
        url: url,
        baseURL: $vm.$api.API_ENDPOINT_STAFF,
        headers: { token: $vm.$session.get("token") },
        data: { icon: this.staffIconDefault },
      })
        .then((res) => {
          if (res.status !== 200) {
            this.toastrExe("Staff Detail", `Update failed.`, "danger");
            return
          }

          this.staffDetails.icon = this.staffIconDefault
          this.$refs.dropzone.removeAllFiles()
          this.getStaffItems()
        })
        .catch((err) => {
          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },

    editStaffTargets(item) {
      this.staffDetails.id = item.staffID;
      this.staffDetails.name = item.name;
      this.staffDetails.service = item.target.service;
      this.staffDetails.product = item.target.product;
      this.staffDetails.package = item.target.package;
      this.staffDetails.outstanding = item.target.outstanding;
      this.staffDetails.includeRedeem = item.target.includeRedeem ? true : false;
    },
    editTargets() {
      let $vm = this;
      let url =
        this.$api.BEBUSINESS_STAFF +
        "/" +
        this.staffDetails.id +
        this.$api.STAFF_TARGET_UPDATE;
      let result = [];

      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: {
            service: $vm.staffDetails.service,
            product: $vm.staffDetails.product,
            package: $vm.staffDetails.package,
            outstanding: $vm.staffDetails.outstanding,
            includeRedeem: $vm.staffDetails.includeRedeem ? 1 : 0,
          },
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.$bvModal.hide("editStaffTargetsModal");


      // this.toastrExe(
      //   "Staff Target",
      //   `Staff ID ${this.staffDetails.id} targets have been updated, refresh to update list.`,
      //   "success"
      // );

      this.isSpinnerShow = true;
      setTimeout(() => {
        this.getStaffItems();
      }, 1000)
    },

    editStaffRole(item) {
      this.staffDetails.id = item.staffID;
      this.staffDetails.name = item.name;
      this.staffDetails.carwasherID = item.carwasher.carwasherID;
      this.staffDetails.carwasher = item.carwasher.carwasherID ? true : false
      this.staffDetails.doctorID = item.doctor.doctorID;
      this.staffDetails.doctor = item.doctor.doctorID ? true : false
      this.staffDetails.stockistID = item.stockist.stockistID;
      this.staffDetails.stockist = item.stockist.stockistID ? true : false
    },
    onCarwasherCheckChange() {
      if (this.staffDetails.carwasher) {
        this.createWD(this.staffDetails.id, this.staffDetails.name, 'carwasher', 'car washer')
      } else {
        this.deleteWD(this.staffDetails.id, this.staffDetails.name, 'carwasher', 'car washer')
      }
    },
    onDoctorCheckChange() {
      if (this.staffDetails.doctor) {
        this.createWD(this.staffDetails.id, this.staffDetails.name, 'doctor', 'doctor')
      } else {
        this.deleteWD(this.staffDetails.id, this.staffDetails.name, 'doctor', 'doctor')
      }
    },
    onStockistCheckChange() {
      if (this.staffDetails.stockist) {
        this.createWD(this.staffDetails.id, this.staffDetails.name, 'stockist', 'stockist')
      } else {
        this.deleteWD(this.staffDetails.id, this.staffDetails.name, 'stockist', 'stockist')
      }
    },
    async createWD(id, name, type, title) {
      let flag = false;
      await Swal.fire({
        title: `Confirm create ${type || title} for ${name}?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
          this.staffDetails[type] = false
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      let url = this.$api.BEBUSINESS_STAFF + "/" + id + '/' + type + '/create';
      let result = [];

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          this.staffDetails[type] = false

          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result.status == 200) {
        this.toastrExe(
          "Create",
          `Staff ${name} transformed into ${type || title}.`,
          "success"
        );

        this.getStaffItems();
      } else {
        this.staffDetails[type] = false
        this.toastrExe("Create", "Error", "danger");
      }
    },
    async deleteWD(id, name, type, title) {
      let flag = false;
      await Swal.fire({
        title: `Confirm remove ${type || title} role for ${name}?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
          this.staffDetails[type] = true
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      let url = this.$api.BEBUSINESS_STAFF + "/" + id + '/' + type + '/delete';
      let result = [];

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          this.staffDetails[type] = true

          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result.status == 200) {
        this.toastrExe(
          "Delete",
          `Staff ${name} is no longer ${type || title}.`,
          "success"
        );
        this.getStaffItems();
      } else {
        this.staffDetails[type] = true
        this.toastrExe("Delete", "Error", "danger");
      }
    },

    editStaffLeave(item, spinner) {
      this.staffLeaveSpinner = spinner === undefined ? true : spinner
      this.staffDetails.id = item.staffID;
      this.staffDetails.name = item.name;

      this.$axios({
        method: "get",
        url: `https://staff.tunai.io/business/staff/${item.staffID}/leaveTotal`,
        headers: { token: this.$session.get("token") },
      })
        .then((response) => {
          this.staffLeaveSpinner = false

          let result = response.data.leaveTotal

          this.staffLeavesCache = {}

          let maxEndDate
          result.forEach(a => {
            let aStart = moment.unix(a['startDate']).toDate()
            a['start'] = { startDate: aStart, endDate: aStart }
            let aEnd = moment.unix(a['endDate']).toDate()
            a['end'] = { startDate: aEnd, endDate: aEnd }

            let key = moment(aStart).startOf('day').unix() + '_' + moment(aEnd).endOf('day').unix()
            this.staffLeavesCache[key] = this.staffLeavesCache[key] || []
            this.staffLeavesCache[key].push(JSON.parse(JSON.stringify(a)))

            if (!maxEndDate || maxEndDate < a['endDate']) {
              maxEndDate = a['endDate']
            }

            a['startError'] = ''
            a['endError'] = ''
            a['totalError'] = ''
          })

          result.sort((a, b) => {
            if (a['startDate'] === b['startDate']) {
              return a['endDate'] - b['endDate']
            }

            return a['startDate'] - b['startDate']
          })

          // let temp = {
          //   start: { startDate: null, endDate: null },
          //   end: { startDate: null, endDate: null },
          //   startError: '',
          //   endError: '',
          //   totalError: '',
          // }
          // if (maxEndDate) {
          //   let start = moment.unix(maxEndDate).add(1, 'day').toDate()
          //   temp['start'] = { startDate: start, endDate: start }
          // }
          // result.push(temp)

          this.leaveTotal = result
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
    onLeaveStartDateChange(index) {
      let temp = this.leaveTotal[index]
      temp['startError'] = ''

      let start = moment(this.leaveTotal[index].start.startDate).startOf('day')
      let end = moment(this.leaveTotal[index].end.startDate).startOf('day')
      if (start.unix() > end.unix()) {
        start = start.add(1, 'day')
        this.leaveTotal[index].end = {
          startDate: start.toDate(),
          endDate: start.toDate(),
        }
      }
    },
    onLeaveEndDateChange(index) {
      let temp = this.leaveTotal[index]
      temp['endError'] = ''

      let start = moment(this.leaveTotal[index].start.startDate).startOf('day')
      let end = moment(this.leaveTotal[index].end.startDate).startOf('day')
      if (start.unix() > end.unix()) {
        end = end.subtract(1, 'day')
        this.leaveTotal[index].start = {
          startDate: end.toDate(),
          endDate: end.toDate(),
        }
      }
    },
    onLeaveTotalChange(index) {
      let temp = this.leaveTotal[index]
      temp['totalError'] = ''
    },
    addLeave() {
      this.leaveTotal.push({
        start: {},
        end: {},
        startError: '',
        endError: '',
        totalError: '',
      })
    },
    async saveLeave() {
      let staffLeavesCache = JSON.parse(JSON.stringify(this.staffLeavesCache)) || []

      let toAddOrUpdate = []
      for (let temp of this.leaveTotal) {
        temp['startError'] = ''
        temp['endError'] = ''
        temp['totalError'] = ''

        if (!temp.start.startDate && !temp.end.startDate && (temp['total'] === undefined || temp['total'] === null || temp['total'] === '')) {
          continue
        }

        let start = moment(temp.start.startDate)
        if (!start || !start.isValid()) {
          temp['startError'] = 'Start date is not valid'
          return
        }
        temp['startMoment'] = start

        let end = moment(temp.end.startDate)
        if (!end || !end.isValid()) {
          temp['endError'] = 'End date is not valid'
          return
        }
        temp['endMoment'] = end

        if (temp['total'] === null || temp['total'] === undefined || temp['total'] === '') {
          temp['totalError'] = 'Leave total is not valid'
          return
        }

        let found = false
        let key = temp['startMoment'].startOf('day').unix() + '_' + temp['endMoment'].endOf('day').unix()
        let list = staffLeavesCache[key]
        if (list) {
          for (let item of list) {
            if (!item['remain'] && String(temp['total']) === String(item['total'])) {
              item['remain'] = true
              found = true
              break
            }
          }
        }

        if (!found) {
          toAddOrUpdate.push(temp)
        }
      }

      let toAdd = []
      for (let temp of toAddOrUpdate) {
        if (!temp.start.startDate && !temp.end.startDate && (temp['total'] === undefined || temp['total'] === null || temp['total'] === '')) {
          continue
        }

        let found = false
        let key = temp['startMoment'].startOf('day').unix() + '_' + temp['endMoment'].endOf('day').unix()
        let list = staffLeavesCache[key]
        if (list) {
          for (let item of list) {
            if (!item['remain'] && !item['update']) {
              item['update'] = true
              item['total'] = temp['total']
              found = true
              break
            }
          }
        }

        if (!found) {
          toAdd.push(temp)
        }
      }

      for (let item of toAdd) {
        let result = await this.$axios({
          method: 'post',
          url: `https://staff.tunai.io/business/staff/${this.staffDetails.id}/leaveTotal`,
          headers: { token: this.$util.getSessionToken() },
          data: {
            start: item['startMoment'].unix(),
            end: item['endMoment'].unix(),
            total: item['total'],
          },
        })
          .then((response) => {
            if (response.status == 200) {
              return true
            }
          })
          .catch((err) => {
            if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
              handleSessionExpired();
              return
            }

            this.errorModalShow = true
            this.errorMessage = this.$i18n.t('message.error.system_error')
          })

        if (!result) {
          return
        }
      }

      for (let key in staffLeavesCache) {
        for (let item of staffLeavesCache[key]) {
          if (item['remain']) {
            continue
          }

          let url
          if (item['update']) {
            url = `https://staff.tunai.io/business/staff/${this.staffDetails.id}/leaveTotal/${item['leaveTotalID']}/update`
          } else {
            url = `https://staff.tunai.io/business/staff/${this.staffDetails.id}/leaveTotal/${item['leaveTotalID']}/delete`
          }

          let result = await this.$axios({
            method: 'post',
            url: url,
            headers: { token: this.$util.getSessionToken() },
            data: {
              // start: item['startMoment'].unix(),
              // end: item['endMoment'].unix(),
              total: item['total'],
            },
          })
            .then((response) => {
              if (response.status == 200) {
                return true
              }
            })
            .catch((err) => {
              console.log(2, err)

              if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                handleSessionExpired();
                return
              }

              this.errorModalShow = true
              this.errorMessage = this.$i18n.t('message.error.system_error')
            })

          if (!result) {
            return
          }
        }
      }

      // this.editStaffLeave({ staffID: this.staffDetails.id, name: this.staffDetails.name })
      // this.getStaffItems()

      this.$bvModal.hide("editStaffLeaveModal");
    },
    saveLeaveBackup(index) {
      // let temp = this.leaveTotal[index]

      // temp['startError'] = ''
      // temp['endError'] = ''
      // temp['totalError'] = ''

      // if((temp.start && temp.start.startDate) || (temp.end && temp.end.startDate) || (temp['total'] === null || temp['total'] === undefined || temp['total'] === '')) {
      //   let start = moment(temp.start.startDate)
      //   if (!start || !start.isValid()) {
      //     temp['startError'] = 'Start date is not valid'
      //     return
      //   }

      //   let end = moment(temp.end.startDate)
      //   if (!end || !end.isValid()) {
      //     temp['endError'] = 'End date is not valid'
      //     return
      //   }

      //   if (temp['total'] === null || temp['total'] === undefined || temp['total'] === '') {
      //     temp['totalError'] = 'Leave total is not valid'
      //     return
      //   }
      // }

      // let url
      // if (temp['leaveTotalID']) {
      //   url = `https://staff.tunai.io/business/staff/${this.staffDetails.id}/leaveTotal/${temp['leaveTotalID']}/update`
      // } else {
      //   url = `https://staff.tunai.io/business/staff/${this.staffDetails.id}/leaveTotal`
      // }

      // let data = {
      //   start: start.startOf('day').unix(),
      //   end: end.endOf('day').unix(),
      //   total: temp['total'],
      // }

      // this.$axios({
      //   method: 'post',
      //   url: url,
      //   headers: { token: this.$util.getSessionToken() },
      //   data: data,
      // })
      //   .then((response) => {
      //     if (response.status == 200) {
      //       this.editStaffLeave({ staffID: this.staffDetails.id, name: this.staffDetails.name })
      //       this.getStaffItems()
      //     }
      //   })
      //   .catch((err) => {
      //     var errData = err.response.data;
      //     if (errData.error == this.$api.INVALID_TOKEN) {
      //       handleSessionExpired();
      //     } else {
      //       // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
      //       this.errorModalShow = true
      //       this.errorMessage = this.$i18n.t('message.error.system_error')
      //     }
      //   })
    },
    confirmDeleteLeave(index) {
      let temp = this.leaveTotal[index]
      this.toDeleteLeaveID = temp['leaveTotalID']
      this.toDeleteLeaveIndex = index
      this.$bvModal.show('staffLeaveTotalDelete')
    },
    deleteLeave() {
      this.leaveTotal.splice(this.toDeleteLeaveIndex, 1)
      this.$bvModal.hide('staffLeaveTotalDelete')

      // let url
      // url = `https://staff.tunai.io/business/staff/${this.staffDetails.id}/leaveTotal/${this.toDeleteLeaveID}/delete`

      // this.$axios({
      //   method: 'post',
      //   url: url,
      //   headers: { token: this.$util.getSessionToken() },
      // })
      //   .then((response) => {
      //     if (response.status == 200) {
      //       this.editStaffLeave({ staffID: this.staffDetails.id, name: this.staffDetails.name })
      //       this.$bvModal.hide('staffLeaveTotalDelete')
      //       this.getStaffItems()
      //     }
      //   })
      //   .catch((err) => {
      //     var errData = err.response.data;
      //     if (errData.error == this.$api.INVALID_TOKEN) {
      //       handleSessionExpired();
      //     } else {
      //       // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
      //       this.errorModalShow = true
      //       this.errorMessage = this.$i18n.t('message.error.system_error')
      //     }
      //   })
    },
  },
  mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse($vm.$store.state.outlets);
    $vm.selectedOutlet = $vm.outlet[0];
    $vm.getStaffItems("");
  },
};
</script>

<style scoped>
.show {
  display: block;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
}

.hoverColumm {
  min-height: 1px;
}

.hoverColumn:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.error-validation {
  font-size: 0.6875rem;
  margin-top: 0.325rem;
  color: #fd3995;
}

.img-thumbnail {
  width: 15em;
}

.item-image {
  width: 12em;
}
</style>